import { Group, RadioGroup, RadioOption, Text } from '@melio/penny';
import { useMelioIntl } from '@melio/platform-i18n';

const optionsValues = ['one_time', 'recurring'] as const;
type OptionValue = (typeof optionsValues)[number];
export function FrequencySelector(props: {
  disabled?: boolean;
  value: OptionValue;
  onChange: (value: OptionValue) => void;
}) {
  const { formatMessage } = useMelioIntl();
  const options: Array<RadioOption> = optionsValues.map((optionValue) => ({
    value: optionValue,
    mainLabelProps: {
      label: formatMessage(`activities.paymentFlow.form.content.frequency.options.${optionValue}`),
    },
  }));

  return (
    <Group variant="vertical" spacing="xxs" data-testid="frequency-selector">
      <Text as="h2" textStyle="body4Semi" color="neutral.darker">
        {formatMessage('activities.paymentFlow.form.content.frequency.label')}
      </Text>
      <RadioGroup
        onChange={(e) => props.onChange(e.target.value as OptionValue)}
        isDisabled={props.disabled}
        value={props.value}
        options={options}
      />
    </Group>
  );
}
